import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL, OFFSET_LIMIT_20 } from '../../Common/constant';
import { fetchAndFilterByBookMark } from '../../../actions';

export const MY_BOOKED_SPONSOR = 'MY_BOOKED_SPONSOR';
export const FETCH_SPONSORS = 'FETCH_SPONSORS';
export const SET_SPONSOR = 'SET_SPONSOR';
export const FETCH_SPONSOR_DETAILS = 'FETCH_SPONSOR_DETAILS';
export const SHOW_ONLY_SPONSOR_DETAILS = 'SHOW_ONLY_SPONSOR_DETAILS';

export const fetchBookedSponsors = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=sponsor)`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?include_count=true&fields=bookmarkid,typeid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKED_SPONSOR,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchAllSponsor = (session, middleWares, callback) => {
  // --- middleWares is a object that has all the surplus params
  let pageCount = middleWares.pagecount ?? 0; // for offset calculation
  let actionType = middleWares.type ?? ''; // ''/'search'/'redirection'
  let searchTerm = middleWares.term ?? ''; // keyword to search
  let sortBy = middleWares.sort ?? 'az'; // DEFAULT 'az'(name) / 'randomly'(createdon)
  let dataArr = middleWares.data ?? []; // previous fetched collection to concat upon
  let reRender = middleWares.rerender ?? false; // true if re-render of list is needed
  let selectedSponsorId = middleWares.id ?? null; // bookmarked / selected sponsor id to filter
  let chunkDataArr =
    reRender && middleWares?.data?.length ? _.chunk(middleWares.data, 20) : [];
  let bookmarkAction = middleWares.action ?? ''; // bookmark action

  // --- pagination handling
  let perPage = OFFSET_LIMIT_20;
  if (reRender && selectedSponsorId && chunkDataArr.length) {
    _.map(chunkDataArr, (chunkItem, chunkIndex) => {
      let filterChunk = _.filter(
        chunkItem,
        spnItem => spnItem.sponsorid == selectedSponsorId
      );

      if (filterChunk.length) pageCount = chunkIndex + 1;
    });
  }
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;

  // --- param handling
  let fetchFilter =
    actionType == 'search'
      ? encodeURI(
          `(eventid=${session.eventid})AND(name CONTAINS ${searchTerm})`
        )
      : encodeURI(`eventid=${session.eventid}`);
  let orderBy =
    actionType != ''
      ? 'name%20ASC'
      : sortBy === 'randomly'
      ? 'createdon%20DESC'
      : 'name%20ASC';

  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?include_count=true&related=membershiptype_by_categoryid&filter=(${fetchFilter})&order=${orderBy}&${offSetQuery}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      response => {
        let responseArr = response.resource;

        // --- bookmark handling
        _.map(responseArr, (spnItem, resourceIndex) => {
          let itemObj = spnItem;

          // - if coming for rerender with selected item id setting key bool value acc. to action
          if (
            selectedSponsorId &&
            spnItem.sponsorid == selectedSponsorId &&
            bookmarkAction != ''
          )
            itemObj.isBookMarked = bookmarkAction == 'unmark' ? false : true;
          else itemObj.isBookMarked = false;

          responseArr[resourceIndex] = itemObj;
        });

        // --- redirection actionType section
        if (actionType == 'redirection' && selectedSponsorId) {
          let filterSpn = _.filter(
            responseArr,
            spn => spn.sponsorid == selectedSponsorId
          );
          dispatch(
            fetchSponsorDetails(session, selectedSponsorId, detailsRes => {
              if (detailsRes.details) {
                dispatch(setSponsor(detailsRes.details));
                if (!filterSpn.length)
                  responseArr = _.concat(detailsRes.details, responseArr);
              }
            })
          );
        }

        // --- payload creation and dispatches
        let payloadObj = {
          count: response.meta.count
        };
        if (reRender) {
          chunkDataArr[pageCount == 0 ? 0 : pageCount - 1] = responseArr;
          payloadObj.resource = _.flatten(chunkDataArr);
        } else payloadObj.resource = dataArr.concat(responseArr);

        dispatch({
          type: FETCH_SPONSORS,
          payload: payloadObj
        });
        callback({
          ...payloadObj,
          success: 1
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const fetchSponsorDetails = (session, sponsorid, callback) => {
  const url = `${INSTANCE_URL}/api/v2/eventifyscript/sponsordetails`;
  const body = {
    eventid: session.eventid,
    appuserid: session.userid,
    sponsorid
  };

  let table_filter = encodeURI(
    `(eventid=${session.eventid})AND(sponsorid=${sponsorid})`
  );
  let table_url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_category,interactivemaps_by_interactivemaplocation_sponsor_link&filter=(${table_filter})`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        getRequest(
          table_url,
          session,
          dispatch,
          res => {
            if (res.resource.length > 0) {
              dispatch({
                type: FETCH_SPONSOR_DETAILS,
                payload: { ...response.data, details: res.resource[0] }
              });
              callback({ ...response.data, details: res.resource[0] });
            } else {
              dispatch({ type: FETCH_SPONSOR_DETAILS, payload: response.data });
              callback(response.data);
            }
          },
          error => {
            dispatch({ type: FETCH_SPONSOR_DETAILS, payload: response.data });
            callback(response.data);
          }
        );
        dispatch({ type: FETCH_SPONSOR_DETAILS, payload: response.data });
        callback(response.data);
      },
      error => {}
    );
  };
};

// --- actions without API call
export const setAllSponsors = allsponsors => {
  return dispatch => {
    dispatch({ type: FETCH_SPONSORS, payload: allsponsors });
  };
};

export const setSponsor = sponsor => {
  return dispatch => {
    dispatch({ type: SET_SPONSOR, payload: sponsor });
  };
};

export const showOnlySponsorDetails = bool => {
  return dispatch => {
    dispatch({ type: SHOW_ONLY_SPONSOR_DETAILS, payload: bool });
  };
};

// --- clear redux values
export const clearAllSponsor = () => {
  return dispatch => {
    dispatch({ type: FETCH_SPONSORS, payload: {} });
  };
};

export const clearSponsorDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_SPONSOR_DETAILS, payload: {} });
  };
};

// These actions are no longer needed
// export const searchSponsor = (session, keywords, callback) => {
//   let filter = encodeURI(
//     `(eventid=${session.eventid})AND(name CONTAINS ${keywords})`
//   );
//   let orderby = 'createdon%20DESC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?include_count=true&related=membershiptype_by_categoryid&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'sponsor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_SPONSORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };

// export const fetchAllSponsor = (session, sortby = 'az', callback) => {
//   let filter = encodeURI(`eventid=${session.eventid}`);
//   // let orderby = 'createdon%20DESC';
//   let orderby = sortby === 'randomly' ? 'createdon%20DESC' : 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?include_count=true&related=membershiptype_by_categoryid&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'sponsor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_SPONSORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };
